export default "__VITE_ASSET__BF$JIbHa__"